import {
  TooltipTrigger as BaseTooltipTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
} from '@eazydraft/ui';
import React from 'react';

export { Tooltip, TooltipContent, TooltipProvider };

type TooltipTriggerProps = React.ComponentProps<typeof BaseTooltipTrigger> & {
  asChild?: boolean;
};

function TooltipTrigger({ asChild, children, ...props }: TooltipTriggerProps) {
  if (asChild && React.isValidElement(children)) {
    return <BaseTooltipTrigger render={children} {...props} />;
  }
  return <BaseTooltipTrigger {...props}>{children}</BaseTooltipTrigger>;
}

export { TooltipTrigger };
